// Each testimonials section includes this file, so it can run more than once per page.
if (!window.TestimonialsCarousel) {
  window.TestimonialsCarousel = class TestimonialsCarousel {
    constructor(carousel) {
      this.carousel = carousel;
      if (!this.carousel) return;
      this.track = this.carousel.querySelector(".testimonials__track");
      this.originalCards = this.carousel.querySelectorAll(".testimonials__card");
      this.prevButton = this.carousel.querySelector(".testimonials__nav-button--prev");
      this.nextButton = this.carousel.querySelector(".testimonials__nav-button--next");
      this.dots = this.carousel.querySelectorAll(".testimonials__dot");
      this.progress = this.carousel.querySelector(".testimonials__progress");
      this.progressFill = this.carousel.querySelector(".testimonials__progress-fill");
      this.isMobile = window.innerWidth < 750;
      this.isAnimating = !1;
      this.currentRealIndex = 0;
      this.pendingIndex = null;
      this.touchStartX = 0;
      this.touchStartY = 0;
      this.touchEndX = 0;
      this.touchEndY = 0;
      this.isSwiping = !1;
      this.init();
    }
    init() {
      this.setupCards();
      this.bindEvents();
      setTimeout(() => this.updateCarousel(!1), 100);
    }
    setupCards() {
      if (this.isMobile) {
        if (this.originalCards.length > 1) {
          const lastCardClone = this.originalCards[this.originalCards.length - 1].cloneNode(!0);
          const firstCardClone = this.originalCards[0].cloneNode(!0);
          lastCardClone.classList.add("testimonials__card--clone", "testimonials__card--clone-before");
          firstCardClone.classList.add("testimonials__card--clone", "testimonials__card--clone-after");
          this.track.insertBefore(lastCardClone, this.track.firstChild);
          this.track.appendChild(firstCardClone);
          this.cards = this.track.querySelectorAll(".testimonials__card");
          this.currentSlide = 1;
          this.totalSlides = this.originalCards.length;
        } else {
          this.cards = this.originalCards;
          this.currentSlide = 0;
          this.totalSlides = this.originalCards.length;
        }
      } else {
        if (this.originalCards.length > 1) {
          const clonesBefore = Array.from(this.originalCards).map((card) => {
            const clone = card.cloneNode(!0);
            clone.classList.add("testimonials__card--clone", "testimonials__card--clone-before");
            return clone;
          });
          const clonesAfter = Array.from(this.originalCards).map((card) => {
            const clone = card.cloneNode(!0);
            clone.classList.add("testimonials__card--clone", "testimonials__card--clone-after");
            return clone;
          });
          clonesBefore.forEach((clone) => this.track.insertBefore(clone, this.track.firstChild));
          clonesAfter.forEach((clone) => this.track.appendChild(clone));
          this.cards = this.track.querySelectorAll(".testimonials__card");
          this.currentSlide = this.originalCards.length;
          this.totalSlides = this.originalCards.length;
        } else {
          this.cards = this.originalCards;
          this.currentSlide = 0;
          this.totalSlides = this.originalCards.length;
        }
      }
    }
    updateCarousel(animate = !0) {
      if (!this.cards[this.currentSlide]) return;
      if (this.isMobile) {
        const targetCard = this.cards[this.currentSlide];
        if (!targetCard) return;
        const containerRect = this.carousel.getBoundingClientRect();
        const cardRect = targetCard.getBoundingClientRect();
        const containerCenter = containerRect.left + containerRect.width / 2;
        const cardCenter = cardRect.left + cardRect.width / 2;
        const currentTransform = getComputedStyle(this.track).transform;
        let currentOffset = 0;
        if (currentTransform && currentTransform !== "none") {
          const matrix = new DOMMatrix(currentTransform);
          currentOffset = matrix.m41;
        }
        const centeringError = cardCenter - containerCenter;
        const newOffset = currentOffset - centeringError;
        if (animate) {
          this.track.style.transition = "transform 0.3s ease";
        } else {
          this.track.style.transition = "none";
        }
        this.track.style.transform = `translateX(${newOffset}px)`;
        if (this.originalCards.length > 1) {
          if (this.currentSlide === 0) {
            setTimeout(
              () => {
                this.currentSlide = this.totalSlides;
                this.updateCarousel(!1);
              },
              animate ? 300 : 0,
            );
          } else if (this.currentSlide === this.totalSlides + 1) {
            setTimeout(
              () => {
                this.currentSlide = 1;
                this.updateCarousel(!1);
              },
              animate ? 300 : 0,
            );
          }
        }
      } else {
        const cardWidth = this.cards[0].offsetWidth;
        const gap = parseInt(getComputedStyle(this.track).gap) || 0;
        const containerWidth = this.carousel.offsetWidth;
        const cardPosition = (cardWidth + gap) * this.currentSlide;
        const centerOffset = containerWidth / 2 - cardWidth / 2;
        const twoCardsOffset = (cardWidth + gap) * 2;
        const newOffset = -(cardPosition - centerOffset + twoCardsOffset);
        if (animate) {
          this.track.style.transition = "transform 0.3s ease";
        } else {
          this.track.style.transition = "none";
        }
        this.track.style.transform = `translateX(${newOffset}px)`;
        if (this.originalCards.length > 1) {
          setTimeout(
            () => {
              if (this.currentSlide < this.totalSlides) {
                this.currentSlide = this.totalSlides + this.currentSlide;
                this.updateCarousel(!1);
              } else if (this.currentSlide >= this.totalSlides * 2) {
                this.currentSlide = this.totalSlides + (this.currentSlide - this.totalSlides * 2);
                this.updateCarousel(!1);
              }
            },
            animate ? 350 : 10,
          );
        }
      }
      if (this.prevButton) this.prevButton.disabled = !1;
      if (this.nextButton) this.nextButton.disabled = !1;
      let realCardIndex;
      if (this.isMobile) {
        if (this.originalCards.length > 1) {
          realCardIndex =
            this.currentSlide === 0
              ? this.totalSlides - 1
              : this.currentSlide === this.totalSlides + 1
                ? 0
                : this.currentSlide - 1;
        } else {
          realCardIndex = this.currentSlide;
        }
      } else {
        if (this.currentSlide < this.totalSlides) {
          realCardIndex = this.currentSlide;
        } else if (this.currentSlide >= this.totalSlides * 2) {
          realCardIndex = this.currentSlide - this.totalSlides * 2;
        } else {
          realCardIndex = this.currentSlide - this.totalSlides;
        }
      }
      this.currentRealIndex = realCardIndex;
      this.dots.forEach((dot, index) => {
        dot.classList.toggle("active", index === realCardIndex);
      });
      this.updateProgress(realCardIndex);
    }
    updateProgress(realCardIndex) {
      if (!this.progressFill) return;
      const ratio = this.totalSlides > 1 ? (realCardIndex + 1) / this.totalSlides : 1;
      this.progressFill.style.width = `${Math.min(1, Math.max(0, ratio)) * 100}%`;
    }
    // Single entry point for "jump to card N", shared by the dots and the progress bar.
    // A request that arrives mid-animation is remembered and replayed once the current
    // slide settles, so dragging the progress bar cannot drop the final position.
    goToRealIndex(index) {
      const target = Math.min(this.totalSlides - 1, Math.max(0, index));
      if (this.isAnimating) {
        this.pendingIndex = target;
        return;
      }
      this.isAnimating = !0;
      if (this.isMobile) {
        this.currentSlide = this.originalCards.length > 1 ? target + 1 : target;
      } else {
        this.currentSlide = this.totalSlides + target;
      }
      this.updateCarousel();
      setTimeout(() => {
        this.isAnimating = !1;
        if (this.pendingIndex !== null) {
          const next = this.pendingIndex;
          this.pendingIndex = null;
          if (next !== this.currentRealIndex) this.goToRealIndex(next);
        }
      }, 350);
    }
    bindEvents() {
      if (this.prevButton) {
        this.prevButton.addEventListener("click", () => {
          if (this.isAnimating) return;
          this.isAnimating = !0;
          if (this.isMobile) {
            if (this.originalCards.length > 1) {
              this.currentSlide--;
            } else {
              this.currentSlide = this.currentSlide === 0 ? this.totalSlides - 1 : this.currentSlide - 1;
            }
          } else {
            this.currentSlide--;
          }
          this.updateCarousel();
          setTimeout(() => {
            this.isAnimating = !1;
          }, 350);
        });
      }
      if (this.nextButton) {
        this.nextButton.addEventListener("click", () => {
          if (this.isAnimating) return;
          this.isAnimating = !0;
          if (this.isMobile) {
            if (this.originalCards.length > 1) {
              this.currentSlide++;
            } else {
              this.currentSlide = this.currentSlide === this.totalSlides - 1 ? 0 : this.currentSlide + 1;
            }
          } else {
            this.currentSlide++;
          }
          this.updateCarousel();
          setTimeout(() => {
            this.isAnimating = !1;
          }, 350);
        });
      }
      this.dots.forEach((dot, index) => {
        dot.addEventListener("click", () => {
          this.goToRealIndex(index);
        });
      });
      this.bindProgressEvents();
      this.bindTouchEvents();
      window.addEventListener("resize", () => {
        setTimeout(() => this.updateCarousel(!1), 50);
      });
    }
    bindProgressEvents() {
      if (!this.progress || this.totalSlides < 2) return;
      let isSeeking = !1;
      const seek = (clientX) => {
        const rect = this.progress.getBoundingClientRect();
        if (!rect.width) return;
        const ratio = Math.min(1, Math.max(0, (clientX - rect.left) / rect.width));
        const target = Math.round(ratio * (this.totalSlides - 1));
        if (target !== this.currentRealIndex) this.goToRealIndex(target);
      };
      this.progress.addEventListener("pointerdown", (e) => {
        isSeeking = !0;
        this.progress.classList.add("is-seeking");
        if (this.progress.setPointerCapture) this.progress.setPointerCapture(e.pointerId);
        seek(e.clientX);
      });
      this.progress.addEventListener("pointermove", (e) => {
        if (isSeeking) seek(e.clientX);
      });
      const endSeek = (e) => {
        if (!isSeeking) return;
        isSeeking = !1;
        this.progress.classList.remove("is-seeking");
        seek(e.clientX);
      };
      this.progress.addEventListener("pointerup", endSeek);
      this.progress.addEventListener("pointercancel", endSeek);
    }
    bindTouchEvents() {
      const handleTouchStart = (e) => {
        if (this.isAnimating) return;
        this.touchStartX = e.touches[0].clientX;
        this.touchStartY = e.touches[0].clientY;
        this.isSwiping = !0;
      };
      const handleTouchMove = (e) => {
        if (!this.isSwiping) return;
        this.touchEndX = e.touches[0].clientX;
        this.touchEndY = e.touches[0].clientY;
        const deltaX = this.touchEndX - this.touchStartX;
        const deltaY = this.touchEndY - this.touchStartY;
        if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 20) {
          e.preventDefault();
        }
      };
      const handleTouchEnd = (e) => {
        if (!this.isSwiping || this.isAnimating) return;
        const deltaX = this.touchEndX - this.touchStartX;
        const deltaY = this.touchEndY - this.touchStartY;
        const minSwipeDistance = 50;
        if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > minSwipeDistance) {
          this.isAnimating = !0;
          if (deltaX > 0) {
            if (this.isMobile) {
              if (this.originalCards.length > 1) {
                this.currentSlide--;
              } else {
                this.currentSlide = this.currentSlide === 0 ? this.totalSlides - 1 : this.currentSlide - 1;
              }
            } else {
              this.currentSlide--;
            }
          } else {
            if (this.isMobile) {
              if (this.originalCards.length > 1) {
                this.currentSlide++;
              } else {
                this.currentSlide = this.currentSlide === this.totalSlides - 1 ? 0 : this.currentSlide + 1;
              }
            } else {
              this.currentSlide++;
            }
          }
          this.updateCarousel(!0);
          setTimeout(() => {
            this.isAnimating = !1;
          }, 350);
        }
        this.isSwiping = !1;
      };
      this.track.addEventListener("touchstart", handleTouchStart, { passive: !1 });
      this.track.addEventListener("touchmove", handleTouchMove, { passive: !1 });
      this.track.addEventListener("touchend", handleTouchEnd, { passive: !0 });
      this.track.addEventListener("contextmenu", (e) => {
        e.preventDefault();
      });
    }
  };

  const initTestimonialsCarousel = (container) => {
    if (!container || container.dataset.carouselInitialized === "true") return;
    container.dataset.carouselInitialized = "true";
    new window.TestimonialsCarousel(container);
  };

  const initTestimonialsCarousels = () => {
    const testimonialsContainers = document.querySelectorAll('[id^="TestimonialsCarousel-"]');
    testimonialsContainers.forEach((container) => {
      initTestimonialsCarousel(container);
    });
  };

  document.addEventListener("DOMContentLoaded", function () {
    initTestimonialsCarousels();
  });

  document.addEventListener("shopify:section:load", function (event) {
    const sectionId = event?.detail?.sectionId;
    if (!sectionId) return;
    const container = document.getElementById(`TestimonialsCarousel-${sectionId}`);
    initTestimonialsCarousel(container);
  });
}
